<!-- <app-header *ngIf="showLayout"></app-header> -->
<main>
  <router-outlet></router-outlet>
</main>
<!-- <app-footer class="pre-footer" *ngIf="showLayout"></app-footer> -->
